module.exports = __webpack_public_path__ + "static/media/hair (1).9218b9e5.jpg";